export default __webpack_public_path__ + "static/media/sleeping-face.9740701e.png";